import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocketItemComponent } from './docket-item/docket-item.component';
import { DocketDetailsComponent } from './docket-details/docket-details.component';
import { FulfillmentSwitcherComponent } from './fulfillment-switcher/fulfillment-switcher.component';
import { IonicModule } from '@ionic/angular';
import { CalendarBarComponent } from './calendar-bar/calendar-bar.component';
import { OrderProgressStatusComponent } from './order-progress-status/order-progress-status.component';
import { DocketDetailsItemComponent } from './docket-details/docket-details-item/docket-details-item.component';
import { DocketDetailsSurchargeComponent } from './docket-details/docket-details-surcharge/docket-details-surcharge.component';
import { DocketDetailsCommentsComponent } from './docket-details/docket-details-comments/docket-details-comments.component';
import { DocketDetailsPromoComponent } from './docket-details/docket-details-promo/docket-details-promo.component';
import { DocketDetailsTipComponent } from './docket-details/docket-details-tip/docket-details-tip.component';
import { TermsAndConditionsComponent } from './modals/terms-and-conditions/terms-and-conditions.component';
import { ForgotPasswordComponent } from './modal-forms/forgot-password/forgot-password.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EtaSelectorComponent } from './modals/eta-selector/eta-selector.component';
import { PipeModule } from '../api/pipe/pipe.module';
import { DirectiveModule } from '../api/directives/directive.module';
import { LoginBackgroundComponent } from './login-background/login-background.component';
import { AppSettingsComponent } from './modals/app-settings/app-settings.component';
import { InfoComponent } from './modals/info/info.component';
import { DocketDetailSingleComponent } from './docket-details/docket-detail-single/docket-detail-single.component';
import { DocketDetailBatchComponent } from './docket-details/docket-detail-batch/docket-detail-batch.component';
import { OrderSortComponent } from './order-sort/order-sort.component';
import { OrderProgressStatusWireframeComponent } from './order-progress-status-wireframe/order-progress-status-wireframe.component';
import { PreserviceAlertComponent } from './custom-alerts/preservice-alert/preservice-alert.component';
import { SearchOrderComponent } from './search-order/search-order.component';
import { HeaderComponent } from './header/header.component';
import { BellComponent } from './shared/bell/bell.component';
import { NoNetworkComponent } from './shared/no-network/no-network.component';
import { LoaderComponent } from './loader/loader.component';
import { BatteryComponent } from './shared/battery/battery.component';
import { PrinterItemComponent } from './printer-item/printer-item.component';
import { PinBoxComponent } from './shared/pin-box/pin-box.component';
import { PinInputComponent } from './shared/pin-input/pin-input.component';
import { PinModalComponent } from './modal-forms/pin-modal/pin-modal.component';
import { ModalNetworkPrinterComponent } from './modal-forms/modal-network-printer/modal-network-printer.component';
import { LoginModalComponent } from './modal-forms/login-modal/login-modal.component';
import { MessageBoardComponent } from './message-board/message-board.component';
import { BumpStatusFilterComponent } from './bump-status-filter/bump-status-filter.component';
import { DragDropIndicatorComponent } from './drag-drop-indicator/drag-drop-indicator.component';
import { CountdownTimerComponent } from './shared/countdown-timer/countdown-timer.component';

@NgModule({
  declarations: [
    DocketItemComponent,
    DocketDetailsComponent,
    DocketDetailsItemComponent,
    DocketDetailsSurchargeComponent,
    DocketDetailsCommentsComponent,
    DocketDetailsPromoComponent,
    DocketDetailsTipComponent,
    DocketDetailSingleComponent,
    DocketDetailBatchComponent,
    FulfillmentSwitcherComponent,
    CalendarBarComponent,
    OrderProgressStatusComponent,
    TermsAndConditionsComponent,
    ForgotPasswordComponent,
    LoginModalComponent,
    EtaSelectorComponent,
    LoginBackgroundComponent,
    AppSettingsComponent,
    InfoComponent,
    OrderSortComponent,
    OrderProgressStatusWireframeComponent,
    SearchOrderComponent,
    PreserviceAlertComponent,
    HeaderComponent,
    BellComponent,
    NoNetworkComponent,
    LoaderComponent,
    BatteryComponent,
    PrinterItemComponent,
    PinInputComponent,
    PinBoxComponent,
    PinModalComponent,
    ModalNetworkPrinterComponent,
    MessageBoardComponent,
    BumpStatusFilterComponent,
    DragDropIndicatorComponent,
    CountdownTimerComponent,
  ],
  exports: [
    DocketItemComponent,
    DocketDetailsComponent,
    DocketDetailsItemComponent,
    DocketDetailsSurchargeComponent,
    DocketDetailsCommentsComponent,
    DocketDetailsPromoComponent,
    DocketDetailsTipComponent,
    DocketDetailSingleComponent,
    DocketDetailBatchComponent,
    FulfillmentSwitcherComponent,
    CalendarBarComponent,
    OrderProgressStatusComponent,
    TermsAndConditionsComponent,
    ForgotPasswordComponent,
    LoginModalComponent,
    EtaSelectorComponent,
    LoginBackgroundComponent,
    AppSettingsComponent,
    InfoComponent,
    OrderSortComponent,
    OrderProgressStatusWireframeComponent,
    SearchOrderComponent,
    PreserviceAlertComponent,
    HeaderComponent,
    BellComponent,
    NoNetworkComponent,
    LoaderComponent,
    PrinterItemComponent,
    PinInputComponent,
    PinBoxComponent,
    PinModalComponent,
    ModalNetworkPrinterComponent,
    MessageBoardComponent,
    BumpStatusFilterComponent,
    DirectiveModule,
    DragDropIndicatorComponent,
    CountdownTimerComponent,
  ],
  imports: [CommonModule, IonicModule, FormsModule, ReactiveFormsModule, PipeModule, DirectiveModule],
})
export class ComponentsModule {}
